// Basic page components - will be enhanced later
import React, { useEffect } from 'react';
import './BasicPages.css';

export const SpolupracePage = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
  <div className="page">
    <section className="page-hero">
      <div className="container">
        <h1>Možnosti spolupráce</h1>
        <p>Rôzne formy spolupráce prispôsobené vašim potrebám</p>
      </div>
    </section>
  </div>
  );
};

export const CennikSluziebiPage = () => (
  <div className="page">
    <section className="page-hero">
      <div className="container">
        <h1>Cenník služieb</h1>
        <p>Transparentné ceny našich IT služieb</p>
      </div>
    </section>
  </div>
);

export const ReferencesPage = () => (
  <div className="page">
    <section className="page-hero">
      <div className="container">
        <h1>Naše referencie</h1>
        <p>Spokojní klienti, ktorí nám dôverujú</p>
      </div>
    </section>
  </div>
);

export const ProfilePage = () => (
  <div className="page">
    <section className="page-hero">
      <div className="container">
        <h1>Profil spoločnosti INVER</h1>
        <p>Viac ako 20 rokov na trhu IT služieb</p>
      </div>
    </section>
  </div>
);

export const SecurityPage = () => (
  <div className="page">
    <section className="page-hero">
      <div className="container">
        <h1>Bezpečnosť</h1>
        <p>Ochrana vašich údajov je našou prioritou</p>
      </div>
    </section>
  </div>
);

export const WebhostingPage = () => (
  <div className="page">
    <section className="page-hero">
      <div className="container">
        <h1>Webhosting</h1>
        <p>Spoľahlivý hosting pre vaše webové stránky</p>
      </div>
    </section>
  </div>
);

export const DedicatedHostingPage = () => (
  <div className="page">
    <section className="page-hero">
      <div className="container">
        <h1>Dedikovaný hosting</h1>
        <p>Výkonný hosting pre náročné aplikácie</p>
      </div>
    </section>
  </div>
);

export const DomainRegistrationPage = () => (
  <div className="page">
    <section className="page-hero">
      <div className="container">
        <h1>Registrácia domén</h1>
        <p>Registrujte si svoju doménu jednoducho</p>
      </div>
    </section>
  </div>
);

export const WebmailPage = () => (
  <div className="page">
    <section className="page-hero">
      <div className="container">
        <h1>Webmail</h1>
        <p>Prístup k emailu kdekoľvek</p>
      </div>
    </section>
  </div>
);

export const TechSalesPage = () => (
  <div className="page">
    <section className="page-hero">
      <div className="container">
        <h1>Predaj techniky</h1>
        <p>Počítače a IT vybavenie</p>
      </div>
    </section>
  </div>
);

export const ActionsPage = () => (
  <div className="page">
    <section className="page-hero">
      <div className="container">
        <h1>AKCIE</h1>
        <p>Aktuálne zľavy a špeciálne ponuky</p>
      </div>
    </section>
  </div>
);

export const ContactPage = () => (
  <div className="page">
    <section className="page-hero">
      <div className="container">
        <h1>Kontakt</h1>
        <p>Spojte sa s nami</p>
      </div>
    </section>
  </div>
);

export const LocationPage = () => (
  <div className="page">
    <section className="page-hero">
      <div className="container">
        <h1>Kde nás nájdete</h1>
        <p>Hutnícka 1, Košice</p>
      </div>
    </section>
  </div>
);